import React, { Component } from "react";
import { Card, Form, Row, Col } from "react-bootstrap";
import axios from "axios";
import CommonToast from "../Toaster/CommonToast";
import CommonLoader from "../loaderComponent/CommonLoader";

export default class MeasurementBillView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      projects: [],
      workOrders: [],
      mbNumber: "",
      mbDate: "",
      customerId: "",
      projectId: "",
      workOrderId: "",
      status: "Draft",
      poItems: [],
      loading: true,
      showToast: false,
      toastMessage: "",
      toastVariant: "",
      errors: {},
      isEdit: false,
      mbId: null,
      color: ""
    };
  }

  componentDidMount() {
    this.fetchCustomers();
    const mbId = this.props.match?.params?.id;
    if (mbId) {
      this.setState({ isEdit: true, mbId });
      this.fetchMeasurementBill(mbId);
    }
  }

  fetchCustomers = () => {
    axios.get("/customer").then((res) => {
      this.setState({ customers: res.data, loading: false });
    }).catch(() => {
      this.setState({ loading: false });
    });
  };

  fetchProjects = (customerId) => {
    axios.get(`/project/customer/${customerId}`).then((res) => {
      this.setState({ projects: res.data });
    });
  };

  fetchWorkOrders = (customerId, projectId) => {
    axios.get(`/workOrders/${customerId}/${projectId}`).then((res) => {
      this.setState({ workOrders: res.data });
    });
  };

  fetchMeasurementBill = (id) => {
    axios.get(`/measurementBill/${id}`).then((res) => {
      const bill = res.data;
      this.setState({
        mbNumber: bill.mbNumber,
        mbDate: bill.mbDate,
        customerId: bill.customerId,
        projectId: bill.projectId,
        workOrderId: bill.workOrderId,
        status: bill.status,
        poItems: bill.items.map((item) => ({
          workOrderItemId: item.workOrderItemId,
          gstValue: item.workOrderItem?.gstValue,
          serialNumber: item.workOrderItem.serialNumber,
          taxableValue: item.workOrderItem.taxableValue,
          totalValue: item.workOrderItem.totalValue,
          rate: item.workOrderItem.rate,
          quantity: item.workOrderItem?.quantity,
          uom: item.uom,
          askedQuantity: item.workOrderItem.quantity,
          pendingQuantity: item.workOrderItem.pendingQuantity,
          labourName: item.workOrderItem.labour?.name || "NA"
        })),
      }, () => {
        this.fetchProjects(bill.customerId);
        this.fetchWorkOrders(bill.customerId, bill.projectId);
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
    }).catch((err) => {
      this.setState({
        showToast: true,
        toastMessage: "Failed to load Measurement Bill data",
        toastVariant: "danger",
        color: "red"
      });
    });
  };

  measurementBillList = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.props.history.push("/measurement-bill");
      this.setState({ loading: false });
    }, 500);
  };

  render() {
    const {
      customers,
      projects,
      workOrders,
      poItems,
      mbNumber,
      mbDate,
      customerId,
      projectId,
      workOrderId,
      errors,
      loading
    } = this.state;

    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={loading}>
          <div className="container-fluid pt-4">
            <Card>
              <Card.Header>
                <div className="purchase-order-back">
                  <b>View Measurement Bill</b>
                  <span style={{ cursor: "pointer" }} onClick={this.measurementBillList}>
                    <i className="far fa-arrow-alt-circle-right"> Measurement Bill List</i>
                  </span>
                </div>
              </Card.Header>
              <Card.Body>
                <Form>
                  <Row>
                    <Col md={3}>
                      <Form.Group controlId="formCustomer">
                        <Form.Label className="required">Customer</Form.Label>
                        <Form.Control as="select" value={customerId} disabled className="form-select">
                          <option value="">Select Customer</option>
                          {customers.map((c) => (
                            <option key={c.id} value={c.id}>{c.name}</option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formProject">
                        <Form.Label className="required">Project</Form.Label>
                        <Form.Control as="select" value={projectId} disabled className="form-select">
                          <option value="">Select Project</option>
                          {projects.map((p) => (
                            <option key={p.id} value={p.id}>{p.name}</option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formWorkOrder">
                        <Form.Label className="required">Work Order</Form.Label>
                        <Form.Control as="select" value={workOrderId} disabled className="form-select">
                          <option value="">Select Work Order</option>
                          {workOrders.map((wo) => (
                            <option key={wo.id} value={wo.id}>{wo.woNumber}</option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md={1}>
                      <Form.Group controlId="formMbNumber">
                        <Form.Label className="required">MB No.</Form.Label>
                        <Form.Control type="text" value={mbNumber} readOnly />
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group controlId="formMbDate">
                        <Form.Label className="required">MB Date</Form.Label>
                        <Form.Control type="date" value={mbDate} readOnly />
                      </Form.Group>
                    </Col>
                  </Row>
                  <hr />
                  <h5>Items</h5>
                  {poItems.map((item, index) => (
                    <Card key={index} className="mb-3">
                      <Card.Body>
                        <Row>
                          <Col md={2}>
                            <Form.Group>
                              <Form.Label>S.No</Form.Label>
                              <Form.Control type="text" value={item.serialNumber} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group>
                              <Form.Label>Labour</Form.Label>
                              <Form.Control type="text" value={item.workOrderItem?.LabourId} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group>
                              <Form.Label>WO Quantity</Form.Label>
                              <Form.Control type="number" value={item.askedQuantity} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group>
                              <Form.Label>Balance Qty</Form.Label>
                              <Form.Control type="number" value={item.pendingQuantity} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group>
                              <Form.Label>UOM</Form.Label>
                              <Form.Control type="text" value={item.uom} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group>
                              <Form.Label>Measured Qty</Form.Label>
                              <Form.Control type="number" value={item.quantity} readOnly />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={2}>
                            <Form.Group>
                              <Form.Label>GST Value</Form.Label>
                              <Form.Control type="number" value={item.gstValue} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group>
                              <Form.Label>Rate</Form.Label>
                              <Form.Control type="number" value={item.rate} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group>
                              <Form.Label>Taxable Value</Form.Label>
                              <Form.Control type="number" value={item.taxableValue} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group>
                              <Form.Label>Total Value</Form.Label>
                              <Form.Control type="number" value={item.totalValue} readOnly />
                            </Form.Group>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  ))}
                </Form>
              </Card.Body>
            </Card>
          </div>
        </CommonLoader>
      </>
    );
  }
}
